module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    class: _vm.classes,
    attrs: {
      "type": "submit",
      "primary": _vm.isPrimary,
      "flat": _vm.isFlat,
      "success": _vm.isSuccess,
      "error": _vm.isError,
      "disabled": _vm.isDisabled,
      "block": _vm.isBlock,
      "color": _vm.color,
      "loading": _vm.request.loading
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.iconText))]), _vm._v(" " + _vm._s(_vm.buttonText) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6ab504a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuexBtn.vue
// module id = 1546
// module chunks = 9